import {SpinningPyramid} from "./SpinningPyramid";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SoundManager} from "../sound/SoundManager";
import {TombOfAkhenatenSoundConfig} from "../TombOfAkhenatenSoundConfig";
import {FullscreenSpinButton} from "@nolimitcity/slot-keypad/bin/core/view/buttons/FullscreenSpinButton";
import {KeypadButtonIDs} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";

export class SpinningPyramidController implements GameRoundPresentation {
    private _spinningPyramidObjArr: SpinningPyramid[] = [];
    private _tl: TimelineLite;
    private _stopTl: TimelineLite;
    private _activePyramidArr: number[] = [];
    private _isGameDataParsed: boolean = false;
    private _gameData: TombOfAkhenatenParsedGameData;
    private _spinStartCounter: number = 0;
    private _spinStopCounter: number = 0;
    private _isAllPyramidSpinStarted: boolean = false;
    public static HIT_DELAY: number = 0.9;
    public static LOST_DELAY: number = 0.4;
    private _fullscreenSpinButton: FullscreenSpinButton;
    public _isAbort: boolean = false;
    private _isStarted : boolean = false;

    constructor() {
        this.addEventListener();
        this.init();
    }

    init() {
        this._spinningPyramidObjArr.push(
            new SpinningPyramid(0, 0),
            new SpinningPyramid(1, 0),
            new SpinningPyramid(2, 0),
            new SpinningPyramid(3, 0),
            new SpinningPyramid(4, 0)
        );

        const layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID_FULL_SCREEN_CLICKER.name);
        this._fullscreenSpinButton = new FullscreenSpinButton(KeypadButtonIDs.FULLSCREEN_SPIN);
        this._fullscreenSpinButton.alpha = 0;
        this._fullscreenSpinButton.addClickCallback(() => this.onAbort());
        layer.addChild(this._fullscreenSpinButton);
        this._fullscreenSpinButton.visible = false;
    }

    onResize() {
        const bounds = NolimitApplication.screenBounds;
        this._fullscreenSpinButton.position.set(bounds.left, bounds.top);
        this._fullscreenSpinButton.width = bounds.width;
        this._fullscreenSpinButton.height = bounds.height;
    }

    onAbort() {
        this._isAbort = true;
        if (this._stopTl?.isActive()) {
            if(this._tl?.isActive()){
                this._tl.pause().kill();
            }
            this._stopTl.progress(1);
        }
        this._activePyramidArr.forEach((pyramidIndex) => {
            this._spinningPyramidObjArr[pyramidIndex].onAbort();
        });
        this.hideFullScreenClicker();
        return null;
    }

    getAnimation(oldData: TombOfAkhenatenParsedGameData): gsap.Timeline | null {
        //#355
        //EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_MULTIPLIER, oldData.payoutMultiplierNextSpin, this._isAbort));
        this._activePyramidArr.length = 0;
        if (GameSetting.isFastSpin) {
            SpinningPyramid.STOP_INTERVAL = 1.125 / 2;
        } else {
            SpinningPyramid.STOP_INTERVAL = 1.125;
        }
        //Logger.logDev("SpinningPyramid All Spinning pyramid spinning Started");

        this._tl = new TimelineLite();
        let counter: number = 0;
        this._isStarted = true;
        if (oldData.showPyramidsReel.includes(true)) {
            oldData.showPyramidsReel.forEach((isActive, index) => {
                if (isActive) {
                    const currSpinningPyramid = this._spinningPyramidObjArr[index];
                    this._tl.add([
                        () => currSpinningPyramid.reset(),
                        () => currSpinningPyramid.show(),
                    ], 0);
                    this._tl.add(() => currSpinningPyramid.play(), 0.5);
                    if (counter == 0) {//first pyramid activities
                        this._tl.add(() => {
                            this.playScaleUpSound();
                            currSpinningPyramid.setFullTransparency();
                        }, 0);
                        this._tl.add(() => {
                            //currSpinningPyramid.playNonWinSymBlink();
                            this.playSpinningSound();
                            currSpinningPyramid.playBgCircleShine();
                        }, 0.6);
                    }
                    counter++;
                    currSpinningPyramid._isLast = oldData.showPyramidsReel.lastIndexOf(true) == index;
                    this._activePyramidArr.push(index);
                }
            });
        }else{
            this.checkForAllSticky();
        }

        return this._tl;
    }

    private checkForAllSticky(){
        if(this._isStarted && this._isGameDataParsed){
            //case for fullReelsSticky scenario
            this._isStarted = false;
            !this._activePyramidArr.length && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ALL_PYRAMID_STOPPED));
        }
    }

    private addEventListener() {
        //SlotKeypad.apiPlugIn.settings.on(APISetting.LEFT_HAND_MODE, () => this.onResize());
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.onNewGameRound());
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => this.onResize());
        EventHandler.addEventListener(this, TOAGameEvent.HIDE_ALL_PYRAMID, (event: GameEvent) => this.hideAllPyramid(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_PYRAMID_SPINNING_STOPPED, (event: GameEvent) => this.onPyramidSpinStopped(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_PYRAMID_SPINNING_STARTED, (event: GameEvent) => this.onPyramidSpinStarted(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.initSpinningPyramid());
        EventHandler.addEventListener(this, TOAGameEvent.ALL_SPIN_STOP_COMPLETE, () => this.onAllSpinStopComplete());
    }

    private onAllSpinStopComplete() {
        this.stopFireAnticipationSound();
    }

    private hideAllPyramid(isFadeOut: boolean = false) {
        this._spinningPyramidObjArr.forEach((spinningPyramid) => {
            if (isFadeOut) {
                TweenLite.to(spinningPyramid, 0.3, {alpha: 0});
            } else {
                spinningPyramid.hide();
            }
        })
    }

    private onPyramidSpinStopped(index: number) {
        this._spinStopCounter++;
        if (this._spinStopCounter == this._activePyramidArr.length) {
            this.hideFullScreenClicker();
            this.stopSpinningSound();//#348
            const delay: number = 0.1;//this._gameData.pyramidReelLand[index] ? SpinningPyramid.HIT_DELAY : SpinningPyramid.LOST_DELAY;
            TweenLite.delayedCall(delay, () => {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ALL_PYRAMID_STOPPED));
                this._isStarted = false;
                this.playNonWinSymAnticipationFire();
            });
        } else {
            const currIndex: number = this._activePyramidArr.indexOf(index);
            const nextPyramidIndex = this._activePyramidArr[currIndex + 1];
            if (this._spinningPyramidObjArr[nextPyramidIndex]) {
                this._spinningPyramidObjArr[nextPyramidIndex].playNonWinSymBlink();
                this._spinningPyramidObjArr[nextPyramidIndex].playBgCircleShine();
                this._spinningPyramidObjArr[nextPyramidIndex].setFullTransparency();
            }
        }
    }

    public playNonWinSymAnticipationFire() {
        if (SpinningPyramid.reelFireFrameArr.size) {
            this.playFireAnticipationSound();
        }
        SpinningPyramid.reelFireFrameArr.forEach((value, key, map) => {
            value[2].show();
            value[2].playLoop();
            value[0].stopLoop();
            value[0].hide();
            value[1].stopLoop();
            value[1].hide();
            if (this._isAbort) {
                value[0].visible = false;
                value[1].visible = false;
            }
        });
    }

    private onPyramidSpinStarted(index: number) {
        this._spinStartCounter++;
        if (this._spinStartCounter == this._activePyramidArr.length) {
            this._isAllPyramidSpinStarted = true;
            this.startStopSetUp();
        }
    }

    private startStopSetUp() {
        if (this._isAllPyramidSpinStarted && this._isGameDataParsed) {
            let prevDelay: number = 0;
            let hitDelay: number = 0;
            if (this._stopTl?.isActive()) {
                this._stopTl.pause().kill();
            }
            this._stopTl = new TimelineLite();
            this._activePyramidArr.forEach((pyramidIndex, index) => {
                const currPyramid = this._spinningPyramidObjArr[pyramidIndex];
                this._stopTl.add(() => currPyramid.onGameDataParsed(this._gameData), 0);
                const delay: number = prevDelay + hitDelay + (pyramidIndex > 0 ? SpinningPyramid.STOP_INTERVAL : 0);
                //add hit delay if current one have hit
                this._stopTl.add(() => {
                    currPyramid.stop();
                    index == 0 && currPyramid.playNonWinSymBlink();//first blink statrted
                }, delay);
                hitDelay = this._gameData.pyramidReelLand[pyramidIndex] ? SpinningPyramidController.HIT_DELAY : SpinningPyramidController.LOST_DELAY;
                prevDelay = delay;
            });
            this.showFullScreenClicker();
        }
    }

    private onNewGameRound() {
        this._spinningPyramidObjArr.forEach((spinningPyramid) => {
            spinningPyramid.onNewGameRound();
        });
        this._activePyramidArr.length = 0;
        this._spinStartCounter = 0;
        this._spinStopCounter = 0;
        this._isAllPyramidSpinStarted = false;
        this._isGameDataParsed = false;
        this._isAbort = false;
        this._isStarted = false;
    }

    private onGameDataParsed(data: TombOfAkhenatenParsedGameData) {
        this._gameData = data;
        if(data.mode == TombOfAkhenatenGameMode.RESPIN_FINAL || data.mode == TombOfAkhenatenGameMode.FS_RESPIN_FINAL){
            this._isGameDataParsed = true;
            if (this._activePyramidArr.length) {
                this.startStopSetUp();
            } else {
                this.checkForAllSticky();
            }
        }
    }

    private initSpinningPyramid() {
        this._spinningPyramidObjArr.forEach((spinningPyramid) => {
            spinningPyramid.init();
        })
    }

    public stopSpinningSound() {
        //Logger.logDev("Sounds pyramidSpinningSound stopSpinningSound");
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_SPINNING);
    }

    public playExplosionSoftSound() {
        //Logger.logDev("ExplosionSound playExplosionSoftSound");
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_EXPLOSION_SOFT);
    }

    private playFireAnticipationSound() {
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_FIRE_ANTICIPATION, Infinity);
    }

    public stopFireAnticipationSound() {
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_FIRE_ANTICIPATION);
    }

    public playWildLandingSound() {
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_LANDING);
    }

    public playScaleUpSound() {
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_SCALE_UP);
    }

    private showFullScreenClicker() {
        this._fullscreenSpinButton.visible = true;
        this._fullscreenSpinButton.enable(true);
    }

    private hideFullScreenClicker() {
        this._fullscreenSpinButton.visible = true;
        this._fullscreenSpinButton.enable(false);
    }

    public playExplosionSound() {
        //Logger.logDev("ExplosionSound playExplosionSound");
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_EXPLOSION);
    }

    public stopExplosionSound() {
        //Logger.logDev("ExplosionSound stopExplosionSound");
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_EXPLOSION);
    }

    public stopExplosionSoftSound() {
        //Logger.logDev("ExplosionSound stopExplosionSoftSound");
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_EXPLOSION_SOFT);
    }

    private playSpinningSound() {
        //Logger.logDev("Sounds pyramidSpinningSound playSpinningSound");
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_SPINNING, Infinity);
    }
}